// extracted by mini-css-extract-plugin
module.exports = {"bar":"_3cl5J","barLabel":"_3rSv6","barValue":"xfvml","barSvg":"_2jYjS","defaultRect":"pmasZ","rect":"_378Nf","bounceX":"hIVWz"};